import { render } from "./scrollable.pug?vue&type=template&id=cd86043e&lang=pug&external"
import script from "./scrollable.js?vue&type=script&lang=js&external"
export * from "./scrollable.js?vue&type=script&lang=js&external"

import "./scrollable.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__